<template>
  <div class="user-guide-wraper">
    <!-- 引导弹窗 -->
    <div v-for="items in data" :key="items.id">
      <div v-if="bootSteps === items.id " :class="items.class">
        <template v-if="items.needMask">
          <template v-if="items.highlightAreaType == 0">
            <div v-if="items.needMask" :class="['user-guide-mask', 'user-guide-mask-' + items.type]" >
              <template v-if="items.type === 'default'">
                <div
                  class="user-guide-top"
                  :style="{
                    height: (items.highlightArea.top + isMsgTop) + 'px'
                  }"></div>
                <div
                  class="user-guide-left"
                  :style="{
                    top: items.highlightArea.top + isMsgTop + 'px',
                    width: items.highlightArea.left + 'px',
                    height: items.highlightArea.height + 'px'
                  }"></div>
                <div
                  class="user-guide-right"
                  :style="{
                    top: items.highlightArea.top + isMsgTop + 'px',
                    left: items.highlightArea.left + items.highlightArea.width + 'px',
                    height: items.highlightArea.height + 'px'
                  }"></div>
                <div
                  class="user-guide-bottom"
                  :style="{
                    top: items.highlightArea.top + isMsgTop + items.highlightArea.height + 'px'
                  }"></div>
              </template>
            </div>
          </template>
           <template v-else-if="items.highlightAreaType == 1">
            <div v-if="items.needMask" :class="['user-guide-mask', 'user-guide-mask-' + items.type]" >
              <template v-if="items.type === 'default'">
                <div v-for="lightItems in items.highlightArea" :key="lightItems.id"
                  :class="['user-guide-mask', 'user-guide-mask-' + items.type]">
                  <template v-if="items.type === 'default'">
                    <div class="user-guide-top" :style="{
                      height: lightItems.top + isMsgTop + 'px',
                      width: '50%',
                      left: lightItems.leftStart,
                    }"></div>
                    <div class="user-guide-left" :style="{
                      top: lightItems.top + isMsgTop + 'px',
                      // width: lightItems.left + 'px',
                      right: lightItems.leftEnd,
                      height: lightItems.height + 'px',
                      left: lightItems.leftStart,
                    }"></div>
                    <div class="user-guide-right" :style="{
                      top: lightItems.top + isMsgTop + 'px',
                      left: lightItems.rightStart,
                      right: lightItems.rightEnd,
                      height: lightItems.height + 'px',
                    }"></div>
                    <div class="user-guide-bottom" :style="{
                      top: lightItems.top + isMsgTop + lightItems.height + 'px',
                      width: '50%',
                      left: lightItems.leftStart,
                    }"></div>
                  </template>
                </div>
              </template>
            </div>
          </template>
        </template>

        <div
          id="content"
          class="user-guide-content"
          :style="items.guideArea ? {
            top: items.guideArea.top + isMsgTop + 'px',
            left: items.guideArea.left + 'px',
          } : null">
          <div class="user-guide-main flex justify-between">
            <div v-if="items.content"  style="white-space: pre-line;">{{ items.content }}</div>
            <i class="el-icon-close size16 gj-ml8 gj-pointer" @click="cancel" style="color: rgba(255, 255, 255, 0.4)"></i>
          </div>
          <div class="flex justify-between align-center gj-mt12">
            <div>{{bootSteps}}/{{data.length}}</div>
            <div v-if="items.btnList.length" class="btnList">
              <div v-if="items.btnList.includes('continue')" class="gj-pointer btn-continue" @click="continueAdd">继续添加</div>
              <div v-if="items.btnList.includes('next')" class="gj-pointer btn-next" @click="nextGuideType">下一步</div>
              <div v-if="items.btnList.includes('video')" class="gj-pointer">
              <gj-link style="color:#fff;" type="text" :href="getVideoUrl(taskItem.videoUrlCode)" target="_blank">参考教程 </gj-link><i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
          <div v-if="items.lineType == 1" class="user-guide-point" :style="{ width: '200px', left: '-200px' }">
            <div class="user-guider-line"></div>
          </div>
          <div v-if="items.lineType == 2" class="user-guide-point-vertical" >
            <div class="user-guider-line-vertical"></div>
          </div>
           <template v-if="items.lineType == 3">
            <div class="user-guide-point" :style="{ width: (items.lineWidth[0] + 'px'), left: ('-' + items.lineWidth[0] + 'px') }">
              <div class="user-guider-line"></div>
            </div>
            <div class="user-guide-point2"  id="lineType3"  :style="{ width: (items.lineWidth[1] + 'px') }">
              <div class="user-guider-line2"></div>
            </div>
          </template>
          <template v-if="items.lineType == 4">
            <!-- <div class="user-guide-point" :style="{ width: '996px', top: '-' + (215 + isMsgTop)+ 'px', left: '-820px' }"> -->
            <div class="user-guide-point" :style="{ width:  (items.lineData.line1.width + 'px'), top: items.lineData.line1.top + 'px', left: items.lineData.line1.left + 'px' }">
              <div class="user-guider-line"></div>
            </div>
            <div class="user-guide-point" :style="{ top: '-' + (215 + isMsgTop)+ 'px', left: '176px' }">
              <div class="user-guider-line3" :style="{ height: (215 + isMsgTop)+ 'px', right: '0' }"></div>
            </div>
            <div class="user-guide-point-vertical-2" :style="{ width: '100px', height:  items.lineData.line3.height + 'px', top: '-' + items.lineData.line3.height + 'px'}">
              <div class="user-guider-line-vertical-2" :style="{ height: items.lineData.line3.height + 'px' }"></div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SET_USER_GUIDE_STATE, SET_USER_GUIDE_MENU_PATH} from "@/store/mutation-types";
import {mapGetters} from "vuex";
import {userGuideMixin} from "@/minxins";
import appUserGuideSucc from "@/views/components/user-guide-succ-modal/user-guide-succ-modal"
import NoviceGuide from '@/views/modules/home/novice-guide/novice-guide'



export default {
  name: "new-user-guide",
  mixins: [userGuideMixin],
  props: {
    guideRef: {
      value: null
    },
    showSupplierQuote: {
      default: false,
      type: Boolean
    }
  },
  data() {

    return {

      bootSteps: 0,
      startStep: 'addSupplier',
      // startStep: 'quotePrice',
      data: [],
      taskName: '',
      taskList: {},
      isMsgTop: 0,
      finishTask: false,
      // taskItem: this.$route.query.taskItem,
      // routerTaskItem: this.$route.query.taskItem,
      taskItem: {},
      routerTaskItem: {},
      subtractHeight: 0,
      addWidth: 0,

    }
  },
  computed: {
    ...mapGetters({
      isMsgsGlobal: 'isMsgsGlobal',
      userGuideState: 'userGuideState'
    })
  },
  watch: {
    isMsgsGlobal: {
      handler(val) {
        this.isMsgTop = val ? 34 : 0;
      },
      immediate: true
    },
    taskName(val){
      if (this.bootSteps === 1){
         this.$emit('taskName', val);
      }
    },

    showSupplierQuote(val){
      this.computeQuote()
    }
  },
  created() {
    this.clientWidth = document.body.clientWidth
    this.taskItem = this.userGuideTaskItem
    this.routerTaskItem = this.userGuideTaskItem
    this.initData()
    this.showGuideViewByTask(this.taskItem)
  },
  methods: {
    initData(){
      const isNavHorizontal = localStorage.getItem('NAV_STATE') !== 'vertical'
      const subtractHeight =  isNavHorizontal ? 0 : 40;
      const addWidth =  isNavHorizontal ? 0 : 60;
      this.subtractHeight = subtractHeight;
      this.addWidth = addWidth;
      this.taskList = {
        addSupplier: [
          {
            id: 1,
            class: "user-guide-one",
            type: 'default',
            needMask: true,
            highlightAreaType: 0,
            highlightArea: {
              width: 174,
              height: 140,
              top: 147 - subtractHeight,
              left: 30 + addWidth,
            },
            guideArea: {
              top: 126 - subtractHeight,
              left: 275 + addWidth,
            },
            content: "您可以通过【添加】按钮逐个添加，也可以通过【导入供应商】按钮批量添加,\n如果没有维护供应商资料，则无法在系统完成采购订单流程哦~",
            btnList: ['video'],
            lineType: 1
          },
          {
            id: 2,
            class: "user-guide-two",
            type: 'default',
            needMask: true,
            highlightAreaType: 0,
            highlightArea: {
              width: this.clientWidth - 60 - addWidth,
              height: 140,
              top: 190 - subtractHeight,
              left: 30 + addWidth,
            },
            guideArea: {
              top: 400 - subtractHeight,
              left: 1000,
            },
            guideRef: null,
            content: "您已添加了供应商资料，可以留在此页面继续添加，也可按照教程继续完成其他任务~",
            btnList: ['continue', 'next'],
            lineType: 2
          }
        ],
        quotePrice: [
          {
            id: 1,
            class: "user-guide-one",
            type: "default",
            needMask: true,
            highlightAreaType: 1,
            highlightArea: [
              {
                id: 1,
                width: 120,
                height: 140,
                top: 147- subtractHeight,
                left: 90,
                leftEnd: this.calcWidth2("100%", (90 + addWidth) + "px"),
                rightStart: (210 + addWidth) + "px",
                rightEnd: "50%",
              },
              {
                id: 2,
                width: 60,
                height: 140,
                top: 195 - subtractHeight,
                right: 100,
                leftStart: "50%",
                leftEnd: "120px",
                rightStart: this.calcWidth2("100%", "60px"),
                isRight: true,
                dataWidth: "200px",
                rightEnd: "0px",
              },
            ],
            guideArea: {
              top: 220 - subtractHeight,
              left: this.clientWidth - 600 - addWidth,
            },
            content: "您可以通过【报价】按钮逐个完成报价，也可以通过【导入报价】按钮批量完成报价\n如果没有完成供应商报价，则无法在系统完成采购订单流程哦~",
            btnList: ["video"],
            lineType: 3,
            lineWidth: [this.clientWidth - 658 - 90 - (addWidth ? addWidth + 50 : addWidth), 90]
          },
          {
            id: 2,
            class: "user-guide-two",
            type: "modal",
            needMask: true,
            guideArea: {
              top: isNavHorizontal ? 480 : 460,
              left: 1430 ,
            },
            guideRef: null,
            content: "您已完成了供应商报价，可以通过【详情】按钮查看报价信息哦~\n您可以留在此页面继续报价，也可按照教程继续完成其他任务~",
            btnList: ["continue",'next'],
            lineType: 4,
            lineData:{
              line1: {
                width: 996,
                top: -(215 + this.isMsgTop),
                left: -820
              },
              line2: {

              },
              line3: {
                height: isNavHorizontal ? 100 : 120

              }
            }
          },
        ]
      }
      this.resetLineLength();
      this.computeQuote()

    },
    showGuideViewByTask(taskItem){
      if (taskItem == null){
        return
      }
      this.taskItem = taskItem;
      const taskChildCode = taskItem.taskChildCode
      if (taskChildCode == 'BASE_DATA_001'){
        this.startStep = 'addSupplier'
      }else if (taskChildCode == 'BASE_DATA_002'){
        this.startStep = 'quotePrice'
        this.$nextTick(() => {
          this.resetLineLength();
        })
      }else {
        this.startStep = ''
      }
      if (this.startStep){
        this.bootSteps = 1
        this.data = this.taskList[this.startStep];
        this.taskName = this.startStep;
        this.$forceUpdate()
      }
    },
    resetLineLength(){
      let content = document.getElementById("content")
      if (content){
        let lineWidth = this.clientWidth - content.getBoundingClientRect().right - 110
        this.taskList.quotePrice[0].lineWidth[1] = lineWidth
        this.$forceUpdate()
      }
    },
    //在数据加载完成后计算数据显示位置
    computeQuote(){

      this.$nextTick(() => {
        this.resetLineLength()
        //设置右边距
        let btn = document.getElementById("dropdown")
        if (btn){
          // let btnLeft = btn.getBoundingClientRect().left
          let btnRight = btn.getBoundingClientRect().right
          let width2 = this.clientWidth - btnRight
          let left2 = this.clientWidth - 402 - width2
          this.taskList.quotePrice[1].guideArea.left = left2
        }else {
          let left1 = this.clientWidth - 402 - 60
          if (left1 > 0){
              this.taskList.quotePrice[1].guideArea.left = left1 
          }
        }

        // 设置 报价信息线段长度
        let content = document.getElementById("supplier-quote")
        if (content){
          let leftX = content.getBoundingClientRect().left
          let leftWidth = leftX + 92 * 3
          console.log('right', right)
          console.log('lineWidth', leftWidth)
          this.taskList.quotePrice[0].lineWidth[1] = lineWidth
          this.$forceUpdate()
        }
      });
    },
    prevStep() {
      this.bootSteps--;
    },
    nextStep(step = null) {
      // this.bootSteps++;
      if(step) {
        this.bootSteps = step
      } else {
        this.bootSteps++;
      }
    },
    temporarilyClosed() { // 暂时关闭，不退出引导状态
      this.bootSteps = 0;
    },
    skip() {
      // 跳过引导
      this.bootSteps = 0;
    },
    cancel() {
      //关闭引导
      this.bootSteps = 0;
      this.$store.commit(SET_USER_GUIDE_STATE, false);
    },
    continueAdd(){
      this.bootSteps = 0;
      this.data = [];
      this.$emit('closeModal');
      this.$store.commit(SET_USER_GUIDE_STATE, false);
    },

    nextGuideType(){
      this.goNextTask();
    },
    async goNextTask(){
      const taskItem = this.taskItem
      const {finishTaskList, nextTask} =  await this.getNextTask(taskItem?.taskTypeCode, taskItem?.taskChildCode)
      if (finishTaskList && this.routerTaskItem.taskStatus != 'COMPLETED'){
        this.completeTask();
      }else if (nextTask){// 有下一步
        if (this.isWaitTurnOn(nextTask.taskStatus)){// 任务未开启，需要 打开新手指引弹窗
          this.$message.warning( `${nextTask.taskChildName}任务未开启，请先开启任务~`)
          this.openNoviceGuide();
        }else if(nextTask.taskChildCode === 'BASE_DATA_001' || nextTask.taskChildCode === 'BASE_DATA_002'){//下一步属于当前组件
          if (nextTask.taskStatus !== 'COMPLETED'){ // 扭转状态
            this.changeTaskStatus(nextTask.taskChildCode);
          }
          this.showGuideViewByTask(nextTask)
        }else {//下一步不属于当前组件，跳转新页面
          this.jumpToGuidePage(nextTask, () => {
            this.bootSteps = 0;
            this.$emit('closeModal');
          })
        }
      }else {
         this.cancel()
      }
    },

    openNoviceGuide() {
      this.bootSteps = 2
      this.startStep = ''
      this.data = [];
      this.$gjCreate(NoviceGuide)
    },
    
    showFinishView(){
      if (this.finishTask){//全部完成
        this.completeTask();
      }else{// 否则
        this.$router.push({ path:'/warehouse/warehouse-information' })
      }
    },
    completeTask() {
      this.bootSteps = 0;
      this.data = [];
      this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
      this.$gjCreate(appUserGuideSucc,{
        global: true,
        props: {
          id: this.taskItem?.taskTypeCode
        }
      })
    },
     calcWidth() {
      let width = "50%";
      let minuend = "110px";
      return `width: calc(${width} - ${minuend})`;
    },
    calcWidth2(w, minuend) {
      let width = `calc(${w} - ${minuend})`;
      return width;
    },
  }
}
</script>
<style lang="scss" scoped>
.user-guide-mask {
  .user-guide-top, .user-guide-left, .user-guide-right, .user-guide-bottom {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2000;
    background: rgba(0, 0, 0, 0.4);
  }
}
.user-guide-mask-menu {
  position: absolute;
    top: 75px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2100;
    background: rgba(0, 0, 0, 0.4);
}

.user-guide-content {
  font-family: PingFang SC;
  font-style: normal;
  padding: 12px 16px;
  background: #4994FC;
  box-sizing: border-box;
  border-radius: 4px;
  width: 402px;
  font-size: 12px;
  color: #fff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.24);
  position: relative;
  position: absolute;
  z-index: 2200;
  .user-guide-point {
    width: 40px;
    position: absolute;
    left: -40px;
    top: 36%;
    .user-guider-line {
      width: 100%;
      height: 2px;
      background: #4994FC;
      &::before { // 小圆点在这里
        content: '';
        border: 1px solid #4994FC;
        background-color: #4994FC;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        margin-top: -4px;
      }
    }

    .user-guider-line3 {
      width: 2px;
      height: 100%;
      background: #4994fc;
    }
  }

  .user-guide-point-vertical {
    width: 40px;
    position: absolute;
    left: 50%;
    top: -120px;

    .user-guider-line-vertical {
      width: 2px;
      height: 120px;
      
      background: #4994FC;
      &::before { // 小圆点在这里
        content: '';
        border: 1px solid #4994FC;
        background-color: #4994FC;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        // top: 50%;
        margin-top: -4px;
        left: -3px;
      }
    }
  }
}

.btnList{
  display: flex;
  flex-direction: row;
  align-items: center;
}

.btn-next{
  width: 68px;
  height: 26px;
  line-height: 26px;
  background: #FFFFFF;
  border-radius: 2px;
  margin-right: 13px;
  color: #4994FC;
  border-radius: 2px;
  font-size: 12px;
  text-align: center;
}

.btn-continue{
  width: 68px;
  height: 26px;
  line-height: 26px;
  background: #4994FC;
  border-radius: 2px;
  border: 1px solid #FFFFFF;
  margin-right: 20px;
  color: #fff;
  border-radius: 2px;
  font-size: 12px;
  text-align: center;
}


 .user-guide-point2 {
    width: 40px;
    // width: var(--variable);
    position: absolute;
    // left: -40px;
    top: 36%;
    left: 100%;
    right: 200px;

    .user-guider-line2 {
      width: 100%;
      height: 2px;
      background: #4994fc;

      &::after {
        // 小圆点在这里
        content: "";
        border: 1px solid #4994fc;
        background-color: #4994fc;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        right: 0;
        // right: -100%;
        // right: 90;
        margin-top: -4px;
      }
    }
  }

  .user-guide-point-vertical-2 {
    width: 40px;
    position: absolute;
    left: 90%;
    top: -100px;

    .user-guider-line-vertical-2 {
      width: 2px;
      height: 100px;

      background: #4994fc;

      &::before {
        // 小圆点在这里
        content: "";
        border: 1px solid #4994fc;
        background-color: #4994fc;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        // top: 50%;
        margin-top: -4px;
        left: -3px;
      }
    }
  }

</style>